<template>
    <div>
        <FormDialog :title="title" :isShow.sync="isShow" width="1154px" v-on:resetForm="close()">
            <div class="analysis-details">
                <div class="main-table-list">
                    <List
                        :isSelection="false"
                        :columns="tableCols"
                        :data="tableData"
                        stripe
                        ref="list"
                    />
                </div>
                <div class="main-pagination">
                    <Pagination :data="pagination" @refresh="pageData" ref="pagination" />
                </div>
            </div>
        </FormDialog>
    </div>
</template>
<script>
import FormDialog from '@/components/dialog/formDialog'
import Pagination from '@/components/pagination/default'
import List from '@/components/list/default'
import { landinifoApi } from '@/api/managementSystemApi'
import { xzqUtils } from '@/views/class/mapmanager'
import { Notification } from 'element-ui'
export default {
  name: 'edit',
  components: {
    FormDialog, Pagination, List
  },
  data() {
    return {
      isShow: false,
      title: '查看详情',
      tableCols: [
        { label: '行政区', prop: 'xzqmc' },
        { label: '平台公司名称', prop: 'sqdw', width: 200 },
        { label: '地块位置', prop: 'dkdz', width: 130 },
        { label: '土地用途', prop: 'tdyt', width: 130 },
        { label: '地块面积(亩)', prop: 'dkmj', width: 120 },
        { label: '成交金额(万元)', prop: 'cjj', width: 120 },
        { label: '成交状态', prop: 'crzt' },
        { label: '过会状态', prop: 'ghzt' },
        { label: '提交时间', prop: 'tjDate', width: 120 }
      ],
      tableData: [],
      xzqParams: [],
      queryData: [],
      pagination: { pageSize: 5, pageNum: 1, total: 0 }, // 分页数据
      tableHeight: 0,
      pageLength: 5
    }
  },
  methods: {
    open(code, queryData) {
      this.isShow = !this.isShow
      this.xzqParams = code
      this.queryData = queryData
      const tjsjList = this.queryData.kssj + ',' + this.queryData.jssj
      let param = {}
      if (this.queryData.kssj === '' && this.queryData.jssj === '') {
        param = {
          pageNo: 0,
          pageSize: 0,
          params: [
            {
              column: 'xzq',
              type: 'EQ',
              val: code
            },
            {
              column: 'ydxz',
              type: 'EQ',
              val: this.queryData.ydxz
            },
            {
              column: 'crzt',
              type: 'EQ',
              val: this.queryData.crzt
            },
            {
              column: 'ghzt',
              type: 'LIKE',
              val: this.queryData.ghzt
            },
            {
              column: 'sqdw',
              type: 'EQ',
              val: this.queryData.sqdw
            }
          ]
        }
      } else {
        param = {
          pageNo: 0,
          pageSize: 0,
          params: [
            {
              column: 'xzq',
              type: 'EQ',
              val: code
            },
            {
              column: 'ydxz',
              type: 'EQ',
              val: this.queryData.ydxz
            },
            {
              column: 'crzt',
              type: 'EQ',
              val: this.queryData.crzt
            },
            {
              column: 'ghzt',
              type: 'LIKE',
              val: this.queryData.ghzt
            },
            {
              column: 'commit_date',
              type: 'BETWEEN',
              val: tjsjList
            },
            {
              column: 'sqdw',
              type: 'EQ',
              val: this.queryData.sqdw
            }
          ]
        }
      }
      landinifoApi.selectByPage(param).then(response => {
        if (response.code === '200') {
          this.tableData = []
          const list = response.data.list
          list.forEach(element => {
            element.xzqmc = xzqUtils.getXZQNAME(element.xzq)
            if (element.ghzt === '0') {
              element.ghzt = '已过会'
            } else {
              element.ghzt = '未过会'
            }
            if (element.crzt === '1') {
              element.crzt = '已出让'
            } else {
              element.crzt = '未出让'
            }
            if (element.dkmj) {
              element.dkmj = parseFloat(element.dkmj).toFixed(3)
            }
          })
          if (list.length < this.pageLength) {
            this.tableData = list
          } else {
            for (let i = 0; i < this.pageLength; i++) {
              this.tableData.push(list[i])
            }
          }
          this.pagination.total = list.length
        } else {
          Notification.warning({
            title: '警告',
            message: '获取数据出错!',
            type: 'warning'
          })
          this.pagination.total = 0
        }
      })
    },
    pageData(data) {
      const xzq = this.xzqParams
      const tjsjList = this.queryData.kssj + ',' + this.queryData.jssj
      let param = {}
      if (this.queryData.kssj === '' && this.queryData.jssj === '') {
        param = {
          pageNo: data.pagination.pageNum,
          pageSize: data.pagination.pageSize,
          total: this.pagination.total,
          params: [
            {
              column: 'xzq',
              type: 'EQ',
              val: xzq
            },
            {
              column: 'ydxz',
              type: 'EQ',
              val: this.queryData.ydxz
            },
            {
              column: 'crzt',
              type: 'EQ',
              val: this.queryData.crzt
            },
            {
              column: 'ghzt',
              type: 'EQ',
              val: this.queryData.ghzt
            },
            {
              column: 'sqdw',
              type: 'EQ',
              val: this.queryData.sqdw
            }
          ]
        }
      } else {
        param = {
          pageNo: data.pagination.pageNum,
          pageSize: data.pagination.pageSize,
          total: this.pagination.total,
          params: [
            {
              column: 'xzq',
              type: 'EQ',
              val: xzq
            },
            {
              column: 'ydxz',
              type: 'EQ',
              val: this.queryData.ydxz
            },
            {
              column: 'crzt',
              type: 'EQ',
              val: this.queryData.crzt
            },
            {
              column: 'ghzt',
              type: 'EQ',
              val: this.queryData.ghzt
            },
            {
              column: 'commit_date',
              type: 'BETWEEN',
              val: tjsjList
            },
            {
              column: 'sqdw',
              type: 'EQ',
              val: this.queryData.sqdw
            }
          ]
        }
      }
      this.pageLength = data.pagination.pageSize
      landinifoApi.selectByPage(param).then(response => {
        if (response.code === '200') {
          this.tableData = []
          const list = response.data.list
          list.forEach(element => {
            element.xzqmc = xzqUtils.getXZQNAME(element.xzq)
            if (element.ghzt === '0') {
              element.ghzt = '已过会'
            } else {
              element.ghzt = '未过会'
            }
            if (element.crzt === '1') {
              element.crzt = '已出让'
            } else {
              element.crzt = '未出让'
            }
            if (element.dkmj) {
              element.dkmj = parseFloat(element.dkmj).toFixed(3)
            }
          })
          this.tableData = list
        } else {
          Notification.warning({
            title: '警告',
            message: '获取数据出错!',
            type: 'warning'
          })
          this.pagination.total = 0
        }
      })
    },
    close() {
      this.isShow = false
      this.tableData = []
      this.xzqParams = []
      this.queryData = []
      this.pagination = { pageSize: 5, pageNum: 1, total: 0 } // 分页数据
      this.tableHeight = 0
      this.pageLength = 5
    }
  }
}
</script>
<style lang="scss" scoped>
@import "@/scss/list.scss";
</style>
